export enum CallStatus {
  RECEIVING_CALL = 'RECEIVING_CALL',
  ON_CALL = 'ON_CALL',
  REFUSED = 'REFUSED',
  CLOSED = 'CLOSED',
  DISCONNECTED = 'DISCONNECTED',
  DISCONNECT_EXTENSION = 'DISCONNECT_EXTENSION',
  CALLING = 'CALLING',
  RECEIVING_TRANSFER = 'RECEIVING_TRANSFER',
  NOTIFY_RINGING = 'NOTIFY_RINGING',
  TRANSFER_DATA = 'TRANSFER_DATA',
  TRANSFER_TRY = 'TRANSFER_TRY',
  TRANSFER_ACCEPTED = 'TRANSFER_ACCEPTED',
  CALL_TIMER = 'CALL_TIMER',
  CALL_STOP_RINGTONE = 'CALL_STOP_RINGTONE',
  TRANSFER_REJECTED = 'TRANSFER_REJECTED',
}
